<template>
  <el-checkbox-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    @update:modelValue="update"
  >
    <el-checkbox-button key="1" :value="true"> Available </el-checkbox-button>
    <el-checkbox-button key="0" :value="false"> On request </el-checkbox-button>
  </el-checkbox-group>
  <el-select v-else v-model="value" multiple @update:modelValue="update">
    <el-option key="1" label="Available" :value="true"> Available </el-option>
    <el-option key="0" label="On request" :value="false">
      On request
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'AvailabilitySelect',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = (newValue: any) => {
      context.emit('update:modelValue', newValue)
    }

    const { isDesktop } = useResize()

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, isDesktop, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
}
</style>
